import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import {
    Popover,
    List,
    ListItemButton,
    Tooltip
} from "@mui/material";

import StyledButton from "../styled/Button";

const LanguageSelect = () => {
    const actualBrowserLanguage = localStorage.getItem("i18nextLng").split("-")[0];
    const selected = ["de", "en", "fr", "cz"].includes(actualBrowserLanguage) ? actualBrowserLanguage : "en";
    const [menuAnchor, setMenuAnchor] = React.useState(null);

    const { t } = useTranslation();

    const languageMap = {
        en: { label: t('Eng'), dir: "ltr", active: true },
        de: { label: t('Deu'), dir: "ltr", active: false },
        fr: { label: t('Fra'), dir: "ltr", active: false },
        cz: { label: t('Cze'), dir: "ltr", active: false }
    };

    useEffect(() => {
        document.body.dir = languageMap[selected].dir;
        document.documentElement.lang = selected;
    }, [menuAnchor, selected]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
        <Tooltip title={t('Select language')} placement="right">
            <StyledButton
                size="small"
                color="secondary"
                variant="outlined"
                sx={{ height: '24px', width: '48px', minWidth: '48px', lineHeight: 0 }}
                onClick={({ currentTarget }) => setMenuAnchor(currentTarget)}
            >
                {languageMap[selected].label}
            </StyledButton>
            <Popover
                open={!!menuAnchor}
                anchorEl={menuAnchor}
                onClose={() => setMenuAnchor(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <List>
                    {Object.keys(languageMap).map((item) => (
                        <ListItemButton
                            key={item}
                            onClick={() => {
                                i18next.changeLanguage(item, (err, t) => {
                                if (err) return console.log('something went wrong loading', err);
                            });
                            i18next.reloadResources(item);
                            setMenuAnchor(null);
                        }}
                        >
                            {languageMap[item].label}
                        </ListItemButton>
                    ))}
                </List>
            </Popover>
        </Tooltip>
    );
};

export default LanguageSelect;
